import script from "./ApenzellComponent.vue?vue&type=script&lang=ts&setup=true"
export * from "./ApenzellComponent.vue?vue&type=script&lang=ts&setup=true"

import "./ApenzellComponent.vue?vue&type=style&index=0&id=fbca06fa&scoped=true&lang=css"

import exportComponent from "/opt/builds/JFRxnycJ/0/firma/firmenwebseite/website/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-fbca06fa"]])

export default __exports__